import React from "react";
import { adminApi as api } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";
import { ImportModal } from "../../components/ImportModal";

export const ImportLabTestsModal = ({ onImport, labId, ...rest }) => {
  const handleImport = async (values) => {
    const params = {
      lab_id: labId,
      file: {
        bytes: values.file,
      },
    };
    const res = await api.post("/admin/tests/background_import.json", snakifyKeys(params));

    if (onImport) {
      onImport(res.data?.meta?.message, res.data?.meta?.error_details);
    }
  };

  return <ImportModal buttonProps={rest} onImport={handleImport} title="Import Tests..." exampleDownloadPath="/admin/tests/example" />;
};
